import React from "react";
import DocumentCustom from "./DocumentCustom";
import styled from "styled-components";

const MessageCard = styled.div`
  width: 250px;
  margin: -5px;
  .main-img-class {
    text-align: center;
    // background-color: #fff;
    // border-radius: 14px;
    // padding: 20px;
  }

  .msg-image__img-msg {
    width: 250px;
    height: 140px;
    border-radius: 14px;
  }

  .card-title-msg {
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    text-align: left;
    color: #000000;
    padding-left: 5px;
    margin-top: 10px;
  }

  .card-desc-msg {
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 23px;
    text-align: left;
    color: #000000;
    padding-left: 5px;
    margin-top: 10px;
  }
  .card-url-msg {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
  }
  .card-url-span-msg {
    font-size: 14px;
    font-weight: 500;
    line-height: 23px;
    text-align: center;
    color: #28a6de;
    word-break: break-word;
  }
    .card-text-choice-msg{
      font-size: 14px;
      font-weight: 600;
      line-height: 23px;
      padding-left: 5px;
    }
  .card-url-icon-msg {
    font-size: 14px;
  }
`;

const CardMsg = ({ message }) => {
  const getYouTubeEmbedUrl = (url) => {
    const regex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([^?&]+)/;
    const match = url.match(regex);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  return (
    <MessageCard>
      <div className="main-img-class">
        {/* <img
          // loading={"lazy"}
          src={`${imgLink}`}
          alt="Image"
          style={{ filter: `blur(${getPixel()}px)` }}
          // onLoad={handleImageLoad}
          className="msg-image__img"
        /> */}
        {message &&
          message.content &&
          message.content.card &&
          message.content.card.media &&
          message.content.card.media.type === "video" && (
            (() => {
              const videoUrl = message.content.card.media.link ? message.content.card.media.link : message.content.card.link;
              const isYouTube = getYouTubeEmbedUrl(videoUrl);
              if (isYouTube) {
                const videoId = isYouTube[1];
                return (
                  <iframe
                    width="155"
                    height="100"
                    className="msg-image__img-msg"
                    src={isYouTube}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                    sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
                    allowFullScreen
                    title="YouTube video"
                  ></iframe>
                );
              }

              return (
                <video width="155" controls className="msg-image__img-msg">
                  <source src={videoUrl} />
                  Your browser does not support the video tag.
                </video>
              );
            })()
          )}


        {message &&
          message.content &&
          message.content.card &&
          message.content.card.media &&
          message.content.card.media.type === "image" && (
            <img
              src={message.content.card.media.link}
              // style={{ width: "100px", height: "80px", borderRadius: "5px" }}
              className="msg-image__img-msg"
            />
          )}

        {message &&
          message.content &&
          message.content.card &&
          message.content.card.media &&
          message.content.card.media.type === "document" && (
            <DocumentCustom message={message} />
          )}
      </div>

      <h4 className="card-title-msg">
        {" "}
        {message.content && message.content.card && message.content.card.title}
      </h4>

      <p className="card-desc-msg">{message.content.card.description}</p>
      {/* {message &&
        message.content &&
        message.content.card &&
        message.content.card.choices[0] &&
        message.content.card.choices[0].url && (
          <a
            className="card-url-msg"
            href={message.content.card.choices[0].url}
            target="_blank"
          >
            <span class="material-symbols-outlined card-url-icon-msg">
              language
            </span>
            <span className="card-url-span-msg">
              {message.content.card.choices[0].url}
            </span>
          </a>
        )} */}
      {message &&
        message.content &&
        message.content.card &&
        message.content.card.choices &&
        message.content.card.choices.length > 0 &&
        message.content.card.choices.map((choice, index) => (
          <div key={choice.id || index}>
            {choice.url ? (
              // If choice contains a URL, render it as a link
              <a
                className="card-url-msg"
                href={choice.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="material-symbols-outlined card-url-icon-msg">
                  language
                </span>
                <span className="card-url-span-msg">{choice.url}</span>
              </a>
            ) : (
              // If choice contains text, render it as a button
              <span className="card-text-choice-msg">{choice.text}</span>
            )}
          </div>
        ))}
    </MessageCard>
  );
};

export default CardMsg;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AssistComponents/CardMsg.js